import React, { Component } from 'react';

// THIS COMPONENT IS USED TO JUST REDIRECT FROM "LOGIN" PAGE TO "ACCEPT TERMS AND CONDITIONS" PAGE
// IF THE USER IS NOT ACCEPTED THE LATEST TERMA AND CONDITIONS  

class Terms extends Component {
    
    constructor(props){
        super();
        this.state = { 
            callAcceptTerms: 0
        }
    }

    componentDidUpdate(prevProps) {
        if(parseInt(this.props.callAcceptTerms,10) > parseInt(this.state.callAcceptTerms,10)) {
            this.setState({callAcceptTerms:this.props.callAcceptTerms}); 
            this.props.redirectToAcceptTerms(); 
        }
    }

    render(){
        return(                
            <div >
                <div ></div>
            </div>
        )
    }
}

export default Terms;